module.exports = __webpack_public_path__ + "static/media/Screenshot2.37c875b5.png";